import { homeHash } from './invite-link.js';
import type { FlowStep } from './machine.js';

/**
 * Hash navigation with the mobile navigator's two verbs: `navigate` pushes (so
 * the browser's Back walks the real sequence) and `replace` swaps (so Back can
 * never return to Calculating, or to a consent screen that was already passed).
 */
export function goStep(step: FlowStep, options: { replace?: boolean } = {}): void {
  const hash = `#/setup/${step}`;
  if (options.replace === true) {
    window.history.replaceState(null, '', hash);
    window.dispatchEvent(new HashChangeEvent('hashchange'));
  } else {
    window.location.hash = hash;
  }
}

export function goHome(): void {
  // "Home" is the invites screen while an invite link is waiting: the person
  // came to accept an invitation, and the flow's finish must not strand them
  // on the dashboard with the reason they came forgotten.
  window.history.replaceState(null, '', homeHash());
  window.dispatchEvent(new HashChangeEvent('hashchange'));
}
